import React from "react";
import ComingSoon from "../../components/coming-soon/ComingSoon";
import { useTranslation } from "src/_common/hooks/useTranslation";
import Sidebar from "src/components/common/Sidebar";
import Header from "src/components/common/Header";
import Footer from "src/components/common/Footer";
import { RODEO_PAGE_NAME } from "src/_config";

interface ComingSoonMainProps {
  feature?: string;
  customTitle?: string;
  customSubtitle?: string;
  showCountdown?: boolean;
  launchDate?: string;
}

export default function ComingSoonMain({
  feature = "Feature",
  customTitle,
  customSubtitle,
  showCountdown = true,
  launchDate
}: ComingSoonMainProps) {
  const { t } = useTranslation('common');

  const getTitle = () => {
    if (customTitle) return customTitle;
    return `${feature} Coming Soon`;
  };

  const getSubtitle = () => {
    if (customSubtitle) return customSubtitle;
    return `We're working hard to bring you an amazing ${feature.toLowerCase()} experience. Stay tuned for updates!`;
  };

  return (
    <>
     <Header variant="topbar" />
      <Sidebar page={RODEO_PAGE_NAME.DASHBOARD} />
    <div className="coming-soon-main">
      <ComingSoon
        title={getTitle()}
        subtitle={getSubtitle()}
        showCountdown={showCountdown}
        launchDate={launchDate}
      />
      
    </div>
    <Footer variant="dashboard" />
    </>
  );
}